var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:{ [_vm.backgroundColor]: true }},[_c('app-drawer'),_c('app-toolbar'),_c('v-content',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }